import { useForm } from "@inertiajs/react";
import Button from "@/components/buttons/Button";
import Input from "@/components/inputs/Input";
import InertiaLink from "@/components/buttons/InertiaLink";
import PageHeader from "@/components/PageHeader";
import SearchSelect from "@/components/inputs/SearchSelect";
import { SelectOption } from "@/components/inputs/Select";
import FormActions from "@/components/buttons/FormActions";

export interface Artist {
  id: number;
  name: string;
}

interface Props {
  artist: Artist;
  current_contributors: SelectOption[];
}

const Edit: React.FC<Props> = ({ artist, current_contributors }) => {
  const { data, setData, put, processing, errors, transform } = useForm({
    name: artist.name,
    contributor_ids: current_contributors,
  });

  transform((data) => ({
    ...data,
    contributor_ids: data.contributor_ids.map((c) => c.value),
  }));

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    put(`/artists/${artist.id}`);
  };

  return (
    <div className="flex w-full flex-col items-start justify-start gap-10">
      <PageHeader
        backLink={{ href: `/artists/${artist.id}`, text: "Back to artist" }}
        title={`Edit ${artist.name}`}
        secondaryAction={{ href: `/artists/${artist.id}`, text: "Cancel" }}
      />
      <form onSubmit={handleSubmit} className="flex w-full flex-col gap-6">
        <Input
          type="text"
          label="Name *"
          value={data.name}
          onChange={(e) => setData("name", e.target.value)}
          placeholder="Enter artist name"
          errors={errors.name}
        />

        <SearchSelect
          label="Contributors"
          name="contributor_ids[]"
          placeholder="Search for contributors"
          reloadPropName="contributor_search_results"
          queryParam="contributor_q"
          value={data.contributor_ids}
          onChange={(items) => setData("contributor_ids", items)}
          errors={errors.contributor_ids}
        />

        <FormActions>
          <InertiaLink
            href={`/artists/${artist.id}`}
            type="secondary"
            text="Cancel"
          />
          <Button
            text={processing ? "Saving..." : "Save"}
            type="primary"
            htmlButtonType="submit"
            disabled={processing}
          />
        </FormActions>
      </form>
    </div>
  );
};

export default Edit;
